<template>
  <div class="container-fluid new_Header">
    <div class="row mb-5">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-3"><router-link to="/">{{$t('nav.home')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="active almarai-bold mx-3" aria-current="page">{{$t('nafath.linkTitle')}}</li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container">
    <!--begin: My Property-->

    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <success v-if="hasSuccess" :message="message" />

    <div class="row justify-content-center mb-5">
      <div class="col-12 col-sm-8">
        <div v-if="GET_USER_DATA.nafathStatus == 'COMPLETED'" class="alert alert-info">{{ $t('nafath.alreadVerified') }}</div>
        <div v-if="GET_USER_DATA.nafathStatus != 'COMPLETED'" class="card">
          <div class="card-body">
            <h5 class="card-title"><i class="fa-solid fa-house-circle-check"></i> {{ $t('nafath.cardTitle') }}</h5>
            <p class="card-text">{{ $t('nafath.wellcome') }} <strong>{{ GET_USER_DATA.userName }}</strong> {{ $t('nafath.verfiyText') }}.</p>
            <div v-if="currentStep == 1" class="row">
              <div class="col">
                <form action="" @submit.prevent="nRequest">
                  <div class="form-group mb-4">
                    <label for="" class="form-label">{{ $t('nafath.identity') }}:</label>
                    <input type="number" v-model="identity" class="form-control" >
                  </div>
                  <div class="form-group text-center">
                    <loader v-if="firstFormLoader" />
                    <input v-else type="submit" class="btn btn-success" :value="$t('nafath.submit')" />
                  </div>
                </form>
              </div>
            </div>

            <div v-if="currentStep == 2" class="row">
              <div class="col-12 mb-3">
                <div class="alert alert-secondary" role="alert">{{ $t('nafath.nafathExplain') }}</div>
              </div>
              <div class="col-12 mb-3 text-center">
                <div class="nafath-number">{{ random }}</div>
              </div>
              <div class="col-12 mb-3 text-center">
                <loader v-if="secondFormLoader" />
                <button v-else type="button" class="btn btn-warning" @click="nCheck">{{ $t('nafath.checkNow') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: "NafathRequest",
  data(){
    return {
      hasError: false,
      errorNumber: 0,
      hasSuccess: false,
      message: "",
      userLang: 'ar',
      currentStep: 1,
      firstFormLoader: false,
      identity: null,
      random: 0,
      secondFormLoader: false,
    }
  },
  computed:{
    ...mapGetters(['ISLOADING', 'GET_USER', 'GET_USER_DATA'])
  },
  
  methods: {
    nRequest(){
      this.hasError = false;
      this.errorNumber = 0;
      this.hasSuccess = false;

      if(!this.identity){
        this.message = this.$t('nafath.identityRequired');
        this.hasError = true;
        window.scrollTo({ top:0, behavior:'smooth'});
        return
      }
      if(`${this.identity}`.length < 10){
        this.message = this.$t('nafath.identityIncorrect');
        this.hasError = true;
        window.scrollTo({ top:0, behavior:'smooth'});
        return
      }

      this.firstFormLoader = true;
      this.$http.post('/api/users/nafathRequest', {
        identity: this.identity,
      }).then(({data}) => {
        this.random = data.random;
        this.currentStep = 2;
        this.identity = null;
        this.firstFormLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.firstFormLoader = false;
        window.scrollTo({ top:0, behavior:'smooth'});
      });
    },
    nCheck(){
      this.hasError = false;
      this.errorNumber = 0;
      this.hasSuccess = false;
      this.secondFormLoader = false;

      this.$http.get('/api/users/checkStatus').then(({data}) => {
        window.location.reload();
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        this.secondFormLoader = false;
        window.scrollTo({ top:0, behavior:'smooth'});
      });
    },
  },
  created(){
    this.userLang = localStorage.getItem('lang') ?? 'ar';
    window.scrollTo({ top:0, behavior:'smooth'});
    if(!this.ISLOADING && !this.GET_USER){
      window.location.href = '/login';
    }
  },
}
</script>